export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading">极速影院</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-md">
              极速影院——免费综艺节目在线观看平台。高清不缓冲，综艺大全涵盖最新热门综艺节目，
              包括音乐竞技、户外真人秀、脱口秀、选秀才艺、美食旅行等多种类型。每日同步更新，
              流畅娱乐体验尽在极速影院。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 font-heading mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '精选推荐', href: '#carousel' },
                { label: '综艺分类', href: '#index' },
                { label: '综艺热度榜', href: '#ranking' },
                { label: '热门话题', href: '#topics' },
                { label: '常见问题', href: '#faq' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-background-50 font-heading mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              诚邀各大综艺制作方、内容平台和品牌方与我们合作，
              共同为观众提供更丰富的综艺娱乐内容。
            </p>
            <p className="mt-3 text-xs text-foreground-500">
              合作联系：partner@jisucinema.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2024 极速影院 JisuCinema. 本站所有综艺节目均来自网络公开资源，仅供个人观看学习。
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                关于我们
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                联系我们
              </a>
              <a
                href="#faq"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#faq')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="text-xs text-foreground-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                常见问题
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}